import React from "react";
import {
    SocialMediaGroup,
    templateActions,
    templateStore,
} from "@pages/Applications/C&C/C&CSetup/templateStore";
import { useSnapshot } from "valtio";
import ReactSwitch from "react-switch";
import { t } from "i18next";

interface ConnectiviteDiversProps {
    path: string[];
}

const ConnectiviteDivers = React.memo(function ConnectiviteDivers({
    path = ["template", "SiteWeb", "Divers", "SocialMedia"],
}: ConnectiviteDiversProps) {
    const snap = useSnapshot(templateStore);

    const initialSocialMediaState = React.useMemo(() => {
        const defaultGroup: SocialMediaGroup = {
            TikTok: { Url: "", Activer: false },
            Youtube: { Url: "", Activer: false },
            Facebook: { Url: "", Activer: false },
            Snapchat: { Url: "", Activer: false },
            Instagram: { Url: "", Activer: false },
        };

        try {
            let current = snap as any;
            for (const key of path) {
                if (current[key] === undefined) {
                    return defaultGroup;
                }
                current = current[key];
            }
            return current ? JSON.parse(JSON.stringify(current)) : defaultGroup;
        } catch (error) {
            console.error("Error initializing social media state:", error);
            return defaultGroup;
        }
    }, [snap, path]);

    const [socialMediaState, setSocialMediaState] = React.useState<
        SocialMediaGroup
    >(initialSocialMediaState);

    const platformToKey = {
        TikTok: "Enter your TikTok URL",
        Facebook: "Enter your Facebook URL",
        Youtube: "Enter your YouTube URL",
        Snapchat: "Enter your Snapchat URL",
        Instagram: "Enter your Instagram URL",
    };
    const handleUpdateUrl = React.useCallback(
        (platform: keyof SocialMediaGroup, value: string) => {
            setSocialMediaState((prev) => ({
                ...prev,
                [platform]: {
                    ...prev[platform],
                    Url: value,
                },
            }));

            templateActions.updateTemplate([...path, platform, "Url"], value);
        },
        [path]
    );

    const handleUpdateActivation = React.useCallback(
        (platform: keyof SocialMediaGroup, value: boolean) => {
            setSocialMediaState((prev) => ({
                ...prev,
                [platform]: {
                    ...prev[platform],
                    Activer: value,
                },
            }));

            templateActions.updateTemplate(
                [...path, platform, "Activer"],
                value
            );
        },
        [path]
    );

    return (
        <div className="mt-3  mx-2">
            <h5 style={{ fontWeight: "bold" }}>{t("Connectivity")}</h5>
            {Object.entries(socialMediaState).map(([platform, config]) => (
                <div
                    key={platform}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "2%",
                    }}
                >
                    <span
                        style={{
                            pointerEvents: "none",
                            cursor: "default",
                            minWidth: "100px",
                        }}
                        className="ml-3 mr-3"
                    >
                        {platform}
                    </span>

                    <input
                        id={`input-${platform}`}
                        type="text"
                        className="form-control epb_inp_timeAS mr-2"
                        value={config.Url}
                        onChange={(e) =>
                            handleUpdateUrl(
                                platform as keyof SocialMediaGroup,
                                e.target.value
                            )
                        }
                        placeholder={t(
                            platformToKey[
                                platform as keyof typeof platformToKey
                            ]
                        )}
                    />

                    <ReactSwitch
                        className="cac_icn_quickConnection"
                        offColor="#faafb4"
                        offHandleColor="#E30613"
                        onColor="#c2eec4"
                        onHandleColor="#34C38F"
                        height={19}
                        handleDiameter={24}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        checked={config.Activer}
                        onChange={(checked) =>
                            handleUpdateActivation(
                                platform as keyof SocialMediaGroup,
                                checked
                            )
                        }
                    />
                </div>
            ))}
        </div>
    );
});

export default ConnectiviteDivers;
